import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { storage } from "../helper/cookieUtils";
import { getAllCourseBlogs } from "../helper/apicalls/courseBlog";
import "../styles/MaterialFolder.scss";
import notAvailable from "../assets/images/notAvalaible.svg";
import GlobalLoader from "../components/GlobalLoader";

const CurrentAffairs = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const courseKeyFromUrl = params.coursekey;
  const storedCourseKey = storage.getItem("courseKey");
  const courseKey = courseKeyFromUrl || storedCourseKey || "";

  useEffect(() => {
    const fetchBlogs = async () => {
      if (!courseKey) return;
      try {
        setLoading(true);
        const res = await getAllCourseBlogs(courseKey);
        const data = Array.isArray(res?.data)
          ? res.data
          : Array.isArray(res)
            ? res
            : [];
        setItems(data);
      } catch (error) {
        console.error("Failed to load current affairs blogs", error);
        setItems([]);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, [courseKey]);

  const handleOpenItem = (item) => {
    const id = item.id || item._id;
    if (!id) return;
    navigate(`/current-affairs/blog/${id}`);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (Number.isNaN(d.getTime())) return "";
    return d.toLocaleDateString(undefined, {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <div className="materials-page custom-scrollbar">
      {loading ? (
        <GlobalLoader />
      ) : items.length === 0 ? (
        <div className="not-found-container">
          <img
            src={notAvailable}
            alt="PowerPoint Icon"
            style={{ width: "300px", height: "300px", marginTop: "4px" }}
          />
          <h3>No Current Affairs Found!</h3>
        </div>
      ) : (
        <div className="current-affairs-list">
          {items.map((item) => {
            const title = item.title || item.name || "Untitled";
            const date = formatDate(item.updated_at || item.created_at);
            const thumb = item.image_url || notAvailable;
            const description = item.blog_description || item.description || "";
            return (
              <div
                key={item.id || item._id}
                onClick={() => handleOpenItem(item)}
                className="current-affairs-card"
              >
                <div className="current-affairs-card__thumb">
                  <img
                    src={thumb}
                    alt={title}
                    className="current-affairs-card__thumb-img"
                    onError={(e) => {
                      e.currentTarget.src = notAvailable;
                    }}
                  />
                </div>
                <div className="current-affairs-card__body">
                  <div className="current-affairs-card__title" title={title}>
                    {title}
                  </div>
                  {description ? (
                    <div
                      className="current-affairs-card__desc"
                      title={description}
                    >
                      {description}
                    </div>
                  ) : null}
                  <div className="current-affairs-card__date">{date}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CurrentAffairs;
